import { c as _c } from "react/compiler-runtime";
import { LinkButton } from '@onefootprint/ui';
import { useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import DocumentItem from '@/entity/components/content/components/document-item';
import { useDecryptForm } from '@/entity/components/decrypt-form';
import type { WithEntityProps } from '@/entity/components/with-entity';
import useDecryptControls from '@/entity/hooks/use-decrypt-controls';
import useDocumentField from '@/entity/hooks/use-document-field';
import type { TransformedDocument } from '@/entity/hooks/use-documents';
import Fieldset from '../fieldset';
export type DocumentFieldsetProps = WithEntityProps & {
  documents: TransformedDocument[];
};
const DocumentFieldset = t0 => {
  const $ = _c(31);
  const {
    entity,
    documents
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "fieldset"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("entity-details", t1);
  const decryptControls = useDecryptControls();
  const decryptForm = useDecryptForm();
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = [];
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== decryptForm.control) {
    t3 = {
      control: decryptForm.control,
      name: "documentKinds",
      defaultValue: t2
    };
    $[2] = decryptForm.control;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const selectedFields = useWatch(t3);
  let t4;
  if ($[4] !== entity) {
    t4 = {
      entity
    };
    $[4] = entity;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const documentField = useDocumentField(t4);
  let t5;
  if ($[6] !== documentField || $[7] !== documents) {
    let t6;
    if ($[9] !== documentField) {
      t6 = document$0 => documentField.getProps(document$0).canSelect;
      $[9] = documentField;
      $[10] = t6;
    } else {
      t6 = $[10];
    }
    t5 = documents.filter(t6);
    $[6] = documentField;
    $[7] = documents;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  const selectableFields = t5;
  const hasSelectableFields = selectableFields.length > 0;
  const allSelected = selectedFields.length === selectableFields.length;
  const shouldShowSelectAll = decryptControls.step === "selecting-fields" && hasSelectableFields;
  const defer = _temp2;
  let t6;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = async () => {
      const documentKinds = Array.from(document.querySelectorAll("input[name=\"documentKinds\"]"));
      for (const checkbox of documentKinds) {
        checkbox.click();
        await defer();
      }
    };
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  const handleToggle = t6;
  let t7;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = [];
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t) {
    t8 = t(_temp3);
    $[13] = t;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  const t9 = documents.length;
  let t10;
  if ($[15] !== allSelected || $[16] !== shouldShowSelectAll || $[17] !== t) {
    t10 = shouldShowSelectAll && <LinkButton variant="label-3" onClick={handleToggle}>{allSelected ? t(_temp4) : t(_temp5)}</LinkButton>;
    $[15] = allSelected;
    $[16] = shouldShowSelectAll;
    $[17] = t;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== documents || $[20] !== entity) {
    let t12;
    if ($[22] !== entity) {
      t12 = document_0 => <li key={document_0.id}><DocumentItem document={document_0} entity={entity} value={`${document_0.kind}-${document_0.completedVersion}`} /></li>;
      $[22] = entity;
      $[23] = t12;
    } else {
      t12 = $[23];
    }
    t11 = documents.map(t12);
    $[19] = documents;
    $[20] = entity;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[24] !== t11) {
    t12 = <ul>{t11}</ul>;
    $[24] = t11;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  let t13;
  if ($[26] !== documents.length || $[27] !== t10 || $[28] !== t12 || $[29] !== t8) {
    t13 = <Fieldset fields={t7} title={t8} count={t9} action={t10}>{t12}</Fieldset>;
    $[26] = documents.length;
    $[27] = t10;
    $[28] = t12;
    $[29] = t8;
    $[30] = t13;
  } else {
    t13 = $[30];
  }
  return t13;
};
export default DocumentFieldset;
function _temp(resolve) {
  return setTimeout(resolve, 0);
}
function _temp2() {
  return new Promise(_temp);
}
function _temp3($) {
  return $.documents.title;
}
function _temp4($_0) {
  return $_0.deselectAll;
}
function _temp5($_1) {
  return $_1.selectAll;
}